var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCloseBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.253,
    height: 12.253,
    viewBox: "0 0 12.253 12.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#000000d9;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H12.253V-12.253H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.253)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -11.253)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0,10.253,10.253"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0,10.253-10.253"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCloseBlueIcon);
export default __webpack_public_path__ + "static/media/x-close-blue-icon.e5383ab47ea3a5792a521eb2ced848f6.svg";
export { ForwardRef as ReactComponent };